import React from 'react'
import { graphql } from 'gatsby'
import get from 'lodash/get'
import Layout from '../components/layout'
import SectionRenderer from '../components/SectionRenderer';
import './page.scss';

class PageTemplate extends React.Component {
  componentDidMount() {
    const page = get(this.props, 'data.contentfulMarketingPage');

    // Inverted Header
    if(page && page.invertedHeader) {
      $('body').addClass('index');
      $('header .logo_inverted').css('opacity', 0);
    }
  }

  render() {
    const page = get(this.props, 'data.contentfulMarketingPage');
    const updatedAt = [page.updatedAt].concat((get(page, 'body.json.content') || []).map(section => get(section, 'data.target.sys.updatedAt'))).filter(Boolean).sort().reverse()[0];

    

    const data = {
      title: page.title,
      slug: page.slug,
      updatedAt,
      title_tag: page.title_tag,
      description_tag: page.description_tag
    }

    return (
      <React.Fragment>
      <Layout location={this.props.location}>
        
        <SectionRenderer json={page.body.json} />
        
      </Layout>
      <script id="data" type="application/json">
        {JSON.stringify(data)}
      </script>
      </React.Fragment>)
  }
}

export default PageTemplate

export const pageQuery = graphql`
  query PageBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    contentfulMarketingPage(slug: {eq: $slug}) {
      title
      invertedHeader
      slug
      updatedAt
      title_tag
      description_tag
      body {
        json
      }
    }
  }
`
